<template>
    <div class="container">
        <div class="section">
            <img src="https://s20.lgstatic.com/growth/activity/20220525/1653474246209.png" alt="">
        </div>
        <div class="section">
            <img src="https://s21.lgstatic.com/growth/activity/20220525/1653444007935.png" alt="">
            <div class="study-container">
                <div class="study-img study-img-1"  @click="handleTrainClick('d68a28c6a455442fbace617b3d27dc54')"></div>
                <div class="study-img study-img-2"  @click="handleTrainClick('595408de2a5b418d82cf75f7b19afaa4')"></div>
                <div class="study-img study-img-3"  @click="handleTrainClick('b9bbe7ae829f4480bc0d860ebf2b1970')"></div>
                <div class="study-img study-img-4"  @click="handleTrainClick('f331871ccf91414896e61eacd84d1429')"></div>
                <div class="study-img study-img-5"  @click="handleTrainClick('ec5e7096784f4c12acb30509179da508')"></div>
                <div class="study-img study-img-6"  @click="handleTrainClick('ed1890dd539543ef9f01d38018e5d3d0')"></div>
                <div class="study-img study-img-7"  @click="handleTrainClick('0279ee5641134bdd9c792ccdf89d319f')"></div>
                <div class="study-img study-img-8"  @click="handleTrainClick('b81a5c0d7dc94c3f88de261065ea56b3')"></div>
            </div>
        </div>
        <div class="section">
            <img src="https://s20.lgstatic.com/growth/activity/20220525/1653444026946.png" alt="">
        </div>
        <div class="section">
            <img src="https://s21.lgstatic.com/growth/activity/20220525/1653444047318.png" alt="">
        </div>
        <div class="section">
            <img src="https://s20.lgstatic.com/growth/activity/20220525/1653474297649.png" alt="">
        </div>
        <div class="footer" @click="visibleModal = true">
            <img src="https://s21.lgstatic.com/growth/activity/20220525/1653444143045.png" alt="">
        </div>
        <div v-if="visibleModal" class="recevice-coupon">
            <div class="recevice-coupon-content">
                <div class="recevice-coupon-wrap">
                    <img class="recevice-coupon-img" src="https://s21.lgstatic.com/growth/activity/20220328/1648461576793.png">
                    <div class="subject-list">
                        <div
                            :class="{
                                'subject-item': true,
                                'actived': selectSubject == subject.type
                            }"
                            v-for="subject in subjectList"
                            :key="subject.type"
                            @click="selectedFn(subject.type)"
                        >{{subject.subjectName}}</div>
                    </div>
                </div>
                <div v-if="!selectSubject" class="recevice-coupon-btn">请选择学科</div>
                <div v-else class="recevice-coupon-btn" @click="selected">选好了，抢占优惠</div>
                <div class="close-btn" @click="visibleModal = false"></div>
            </div>
        </div>
    </div>
</template>

<script>
import * as Cookies from 'js-cookie';
import { handleJumpUrl } from '../../../uitl/getParam.js';
export default {
    data() {
        return {
            subjectList: [
                { type: 1, subjectName: "Java", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709857214.png',url: 'https://edu.lagou.com/growth/sem/java_architect.html', formId: 'd68a28c6a455442fbace617b3d27dc54' },
                { type: 2, subjectName: "前端", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709872346.png',url: 'https://edu.lagou.com/growth/sem/fe-next.html', formId: '595408de2a5b418d82cf75f7b19afaa4' },
                { type: 3, subjectName: "大数据", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709884836.png',url: 'https://edu.lagou.com/growth/sem/data_enhancement.html', formId: 'b9bbe7ae829f4480bc0d860ebf2b1970' },
                { type: 4, subjectName: "数据分析", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709822126.png',url: 'https://edu.lagou.com/growth/sem/data_analysis.html', formId: 'ec5e7096784f4c12acb30509179da508' },
                { type: 5, subjectName: "测试", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709900045.png',url: 'https://edu.lagou.com/growth/sem/test_engineer.html', formId: '0279ee5641134bdd9c792ccdf89d319f' },
                { type: 6, subjectName: "产品", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709914157.png',url: 'https://edu.lagou.com/growth/sem/pm__enhancement.html', formId: 'f331871ccf91414896e61eacd84d1429' },
                { type: 7, subjectName: "运营", imgUrl: 'https://s20.lgstatic.com/growth/activity/20220331/1648709925863.png',url: 'https://edu.lagou.com/growth/sem/all_operate.html', formId: 'b81a5c0d7dc94c3f88de261065ea56b3' },
                { type: 8, subjectName: "商业分析", imgUrl: 'https://s20.lgstatic.com/growth/activity/20220331/1648709925863.png',url: 'https://edu.lagou.com/growth/sem/all_operate.html', formId: 'ed1890dd539543ef9f01d38018e5d3d0' }
            ],
            selectSubject: '',
            visibleModal: false
        }
    },
    created () {
       
    },
    methods: {
        selected() {
            const formId = this.subjectList[this.selectSubject - 1].formId || '';
            handleJumpUrl(formId);
        },
        selectedFn(type) {
            this.selectSubject = type;
        },
        handleTrainClick(formId) {
            handleJumpUrl(formId);
        },
        isLogin() {
            return Cookies.get('gate_login_token') || Cookies.get('edu_gate_login_token');
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    position: relative;
    width: 100%;
    overflow-y: auto;
    padding-bottom: 237px;
}
.section {
    position: relative;
    display: flex;
    width: 100%;
    img {
        width: 100%;
    }
}
.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 237px;
    img {
        width: 100%;
    }
}
.study-container {
    position: absolute;
    left: 30px;
    top: 100px;
    width: 690px;
    height: 887px;
    .study-img {
        position: absolute;
        width: 274px;
        height: 60px;
        &-1 {
            top: 255px;
            left: 33px;
        }
        &-2 {
            top: 255px;
            right: 32px;
        }
        &-3 {
            top: 635px;
            left: 33px;
        }
        &-4 {
            top: 635px;
            right: 32px;
        }
        &-5 {
            top: 1015px;
            left: 33px;
        }
        &-6 {
            top: 1015px;
            right: 32px;
        }
        &-7 {
            top: 1385px;
            left: 33px;
        }
        &-8 {
            top: 1385px;
            right: 32px;
        }
    }
}
.recevice-coupon {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 1, 31, .45);
    .recevice-coupon-content {
        position: absolute;
        top: 45%;
        left: 50%;
        width: 600px;
        height: 550px;
        transform: translateX(-50%) translateY(-50%);
    }
    .recevice-coupon-wrap {
        width: 600px;
        height: 555px;
        background-color: #FF8315;
        border-radius: 12px;
        overflow: hidden;
        .recevice-coupon-img {
            display: block;
            width: 324px;
            height: 87px;
            margin: 92px auto 0;
        }
        .subject-list {
            display: flex;
            width: 560px;
            height: 212px;
            padding-top: 42px;
            margin: 47px auto 0;
            box-sizing: border-box;
            background-color: #F17100;
            border-radius: 4px;
            justify-content: center;
            flex-wrap: wrap;
            .subject-item {
                min-width: 113px;
                height: 54px;
                line-height: 54px;
                padding: 0 14px;
                box-sizing: border-box;
                font-size: 26px;
                color: #fff;
                text-align: center;
                margin-bottom: 27px;
                margin-right: 20px;
                background-color: #FFA85B;
                border-radius: 3px;
                &:nth-child(4n) {
                    margin-right: 0;
                }
                &.actived {
                    background-color: #A95000;
                }
            }
        }
    }
    .recevice-coupon-btn {
        position: absolute;
        bottom: -40px;
        left: 50%;
        width: 389px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        border-radius: 40px;
        background: linear-gradient(180deg, #FFFFFF 0%, #FFDDBF 100%);
        font-size: 36px;
        font-weight: bold;
        color: #E96D00;
        transform: translateX(-50%);
    }
    .close-btn {
        position: absolute;
        bottom: -140px;
        left: 50%;
        width: 70px;
        height: 70px;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 70px 70px;
        transform: translateX(-50%);
    }
}
</style>
